import React, { useCallback, useMemo, useState, useContext } from "react";
import { Box, Button, Dialog, DialogContent, Divider, IconButton, ListItemIcon, Menu, MenuItem, Paper, Typography } from "@mui/material"
import MoreVertRounded from "@mui/icons-material/MoreVertRounded";
import { AddRounded, CloseRounded, DeleteRounded, SaveRounded } from "resource/muiImport";
import useCompactLayout from "hooks/useCompactLayout";
import ModAccName from "components/ModAccName";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import { initDialogData, shipmentApiNm, shipmentColNm } from "constants/shipmentConstant";
import { getISOCd, sortObj, validate } from "utils";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import FileUpload from "components/FileUplaod/FileUpload";
import { coreApiNm, FOLDER_SHIPMENT_FILE } from "constants/serverConstant";
import dayjs from "dayjs";
import { initFileUploadData } from "constants/fileUploadConstant";
import ShipmentData from "components/ShipmentData";
// import MemoComponent from "components/MemoComponent";
import { useEffect } from "react";
import { BoxFC, BoxFR } from "components/BoxCustom";
import PaperComponent from "components/PaperComponent";
import CheckboxFormControl from "components/CheckboxFormControl";
import { alertConfirmDelete, alertConfirmPromise, alertError, alertWarning } from "components/Alert";
import { saveFile } from "components/FileUplaod/saveFile";
import { blueGrey } from "@mui/material/colors";
import { ContentCopyRounded, DocumentScannerRounded, HistoryRounded, PrintRounded } from "resource/muiImport";
import LogTableDialog from "components/LogTableDialog/LogTableDialog";
import PrintJobOrderDialog from "./PrintJobOrderDialog";
import { printShipment } from "branch/functions/printShipment";
import { getDataAndPrintJobOrderByShpmId } from "utils/getDataAndPrintjobOrder";
import { UserContext } from "contexts/UserContext";
import ReadFileDialog from "./ReadFileDialog";
import ReadBLDialog from "./ReadBLDialog";
import ReadBookingDialog from "./ReadBookingDialog";

const excludeKeys = ["ShpmLogId", "ShpmId", "ModDte", "ModAcc"]
let firstData = null;
let oldData = null;
const ShipmentDialog = ({ state, fn }) => {
  const { user } = useContext(UserContext)

  const { dialogOpen, selectedId, lastFilter, oneYearVsslData = [], oneYearPortData = [], isInsertReturnShpmId } = state
  const { setDialogOpen, onFinish } = fn
  const [dialogReadFileOpen, setDilaogReadFileOpen] = useState(false)
  const [dialogData, setDialogData] = useState(initDialogData)
  const { ax, msData } = useContext(GlobalStateContext);
  const [fileUploadData, setFileUploadData] = useState({ ...initFileUploadData() })
  const [isShowShipmentData, setIsShowShipmentData] = useState(true)
  const [memoData, setMemoData] = useState([])
  const [isClearData, setIsClearData] = useState(true)
  const [mShpmId, setmShpmId] = useState(0)
  const [dialogPrintJobOrderOpen, setDialogPrintJobOrderOpen] = useState(false)
  const [dialogReadFileBLOpen, setDialogReadFileBLOpen] = useState(false)
  const [dialogReadFileBookingOpen, setDialogReadFileBookingOpen] = useState(false)
  const [dialogHistoryOpen, setDialogHistoryOpen] = useState(false)
  const isCompact = useCompactLayout()
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [saving, setSaving] = useState(false)




  initDialogData.RecvDocDte = dayjs();

  const validation = useMemo(() => ({
    RecvDocDte: dialogData.RecvDocDte == null || !dayjs(dialogData.RecvDocDte).isValid(),
    JobNo: dialogData.JobNo === "",
    ShpmTypId: dialogData.ShpmTypId === "" || dialogData.ShpmTypId === null,
    JobId: dialogData.JobId === null,
    TakeDteSt: dialogData.TakeDteSt != null && !dayjs(dialogData.TakeDteSt).isValid(),
    TakeDteEn: dialogData.TakeDteEn != null && !dayjs(dialogData.TakeDteEn).isValid(),
    RtnDteSt: dialogData.RtnDteSt != null && !dayjs(dialogData.RtnDteSt).isValid(),
    RtnDteEn: dialogData.RtnDteEn != null && !dayjs(dialogData.RtnDteEn).isValid(),
  }), [dialogData])

  // const getMemoArgs = useMemo(() => ({
  //   ShpmId: dialogData.ShpmId
  // }), [dialogData.ShpmId])

  const deleteShipment = useCallback((shpmId) => {
    alertConfirmDelete(() => {
      ax.post(shipmentApiNm.deleteShipment, { ShpmId: shpmId, getArgs: lastFilter }).then(value => {
        if (value.data) {
          if (onFinish) {
            onFinish(value.data);
          }

          setDialogOpen(false);
        }
      })
    })
  }, [ax, lastFilter, onFinish, setDialogOpen])

  const insertUpdateShipment = useCallback(async (initShpmId, dialogData, fileUploadData, setFileUploadData, memData
    , isClearData, withPrintJobOrder) => {
    const isInsert = initShpmId === 0;
    for (const file of fileUploadData.serverFiles) {
      if (file.isEdit) {
        alertWarning("กรุณายืนยันชื่อไฟล์ก่อน");
        return;
      }
    }
    for (const file of fileUploadData.addedFiles) {
      if (file.isEdit) {
        alertWarning("กรุณายืนยันชื่อไฟล์ก่อน");
        return;
      }
    }




    let value = null
    let shpmId = initShpmId
    if (dialogData) {
      if (!isInsert && dialogData.ShpmTypId === 1
        && oldData.Vssl !== dialogData.Vssl && oldData.RtnDteEn === dialogData.RtnDteEn) {
        const result = await alertConfirmPromise({
          message: "ชื่อเรือเปลี่ยนแปลง แต่เวลาปิดคืนไม่เปลี่ยน ต้องการแก้ไขข้อมูลหรือไม่?",
          okText: "แก้ไขข้อมูล",
          cancelText: "ยกเลิก"
        });
        if (!result) {
          return
        }
      }
      const postData = {
        ...dialogData,
        getArgs: lastFilter
      }
      dialogData.getArgs = lastFilter;
      value = await ax.post(isInsert ? shipmentApiNm.insertShipment : shipmentApiNm.updateShipment, postData);
      if (isInsert) shpmId = value.data
      if (!value.data) {
        return
      }
    }

    const refreshFromFile = fileUploadData.addedFiles.length > 0 || fileUploadData.deletedFiles.length > 0

    await saveFile({
      ax, alertWarning, fileUploadData, setFileUploadData,
      apiUpdateFileName: shipmentApiNm.updateFileName,
      apiDeleteFile: shipmentApiNm.deleteFile,
      apiAddFile: shipmentApiNm.uploadFile,
      key: "ShpmFileId",
      refKey: "ShpmId",
      refValue: shpmId
    })

    for (const data of memData) {
      if (isInsert) {
        data.RefId = shpmId
      }
      if (data.MemId > 0) {
        await ax.post(coreApiNm.updateMemo, data)
      } else {
        await ax.post(coreApiNm.insertMemo, data)
      }
    }

    if (withPrintJobOrder) {
      await getDataAndPrintJobOrderByShpmId(ax, msData, shpmId, user.FName)
    }

    if (onFinish) {

      if (isInsert) {
        if (isInsertReturnShpmId) {
          onFinish(shpmId)
        } else {
          onFinish(null)
        }
      } else if (dialogData) {
        onFinish(value.data)
      } else if (memData && memData.length > 0) {
        onFinish(null)
      } else if (refreshFromFile) {
        onFinish(null)
      }
    }
    if (isClearData) {
      setDialogOpen(false);
    } else {
      setDialogData(o => ({ ...o, JobNo: "" }))
    }

    return shpmId
  }, [ax, lastFilter, onFinish, setDialogOpen, isInsertReturnShpmId, msData, user.FName])

  const handlePrintDialogFinish = useCallback((data) => {
    if (isInsertReturnShpmId) {
      onFinish(mShpmId)
    } else {
      onFinish(data)
    }
  }, [onFinish, isInsertReturnShpmId, mShpmId]
  )

  const handleDialogOK = useCallback(async (withPrintJobOrder) => {
    if (!validate(validation)) return;
    let postDialogData = null;
    if (!dialogData.ShpmId && dialogData.JobOrders && dialogData.JobOrders.length > 0) {
      const validContSize = msData.contSizeCombo.map(item => item.id)
      const validContTyp = msData.contTypCombo.map(item => item.id)
      for (const jo of dialogData.JobOrders) {
        if (!jo.AptTm) {
          alertError("กรุณากรอกเวลานัดส่ง")
          return
        }
        if (!jo.NumJobOrd) {
          alertError("กรุณาระบุจำนวนใบงาน")
          return
        }
        if (!validContSize.includes(jo.ContSize)) {
          alertError(`ขนาดตู้ (Size) "${jo.ContSize ?? ""}" ไม่ถูกต้อง กรุณาเลือกจากรายการ`)
          return
        }
        if (!validContTyp.includes(jo.ContTyp)) {
          alertError(`ประเภทตู้ (Type) "${jo.ContTyp ?? ""}" ไม่ถูกต้อง กรุณาเลือกจากรายการ`)
          return
        }
        if (jo.ContHq !== 0 && jo.ContHq !== 1) {
          alertError(`HQ "${jo.ContHq ?? ""}" ไม่ถูกต้อง กรุณาเลือกจากรายการ`)
          return
        }
        jo.ISOCd = getISOCd(jo.ContSize, jo.ContTyp, jo.ContHq)

      }
    }
    if (JSON.stringify(dialogData) !== JSON.stringify(firstData)) {
      postDialogData = { ...dialogData }
    }
    return await insertUpdateShipment(dialogData.ShpmId, postDialogData, fileUploadData, setFileUploadData, memoData
      , isClearData, withPrintJobOrder)
  }, [validation, dialogData, fileUploadData, memoData, insertUpdateShipment, isClearData, msData.contSizeCombo, msData.contTypCombo])


  //useDialogOpen(dialogOpen, mShpmId, shipmentApiNm.getShipment, "ShpmId", setDialogData, initDialogData, modifyData)
  const handleCopyShipment = useCallback(() => {
    setDialogData(o => ({ ...o, ShpmId: 0 }))
    setmShpmId(0)
  }, [])

  const handlePrintJobOrder = useCallback(() => {
    setDialogPrintJobOrderOpen(true)
  }, [])

  const insertAndPrintJobOrder = useCallback(async () => {
    if (!dialogData.JobOrders || dialogData.JobOrders.length === 0) {
      alertError("กรุณาระบุข้อมูลใบงาน")
      return
    }

    return handleDialogOK(true)
    // if (shpmId > 0) {
    //   setDialogData(o => ({ ...o, ShpmId: shpmId }))
    //   setmShpmId(shpmId)
    //   setDialogPrintJobOrderOpen(true)
    // }
  }, [handleDialogOK, dialogData.JobOrders])

  const handlePrintShipmet = useCallback(() => {
    ax.post(shipmentApiNm.getPrintData, { ShpmId: selectedId }).then(value => {
      if (value.data && value.data.length === 1) {
        const shData = value.data[0]
        shData.JobOrders = sortObj(shData.JobOrders, "AptTm", "ContSizeFull")
        printShipment({ shData: shData, msData, user: user })
      }
    })
  }, [ax, selectedId, msData, user])

  const onDialogReadFileFinish = useCallback((data) => {
    console.log("onDialogReadFileFinish", data)
    if (data.VolArr) {
      const groupedMap = new Map();
      data.VolArr.forEach(it => {
        if (!it) return;
        const ContSize = it.ContSize
        const ContTyp = it.ContTyp
        const ContHq = it.ContHq
        const key = `${ContSize}|${ContTyp}|${ContHq}`;
        const qty = Number(it.Qty) || 0;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, { ...it, ContSize, ContTyp, ContHq, Qty: qty });
        } else {
          groupedMap.get(key).Qty += qty;
        }
      });
      data.VolArr = Array.from(groupedMap.values());
    }
    setDialogData(o => ({
      ...o,
      ...data,
      RecvDocDte: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      ShpmTypId: o.ShpmTypId,
      JobNo: o.JobNo ? o.JobNo : ((data.JobNo && data.JobNo !== "N/A") ? data.JobNo : data.Bkg) || "",
      JobOrders: Array.isArray(data.VolArr) ? data.VolArr.map(item => ({
        AptTm: null,
        ContSize: item?.ContSize,
        ContTyp: item?.ContTyp,
        ContHq: item?.ContHq,
        NumJobOrd: item?.Qty || 1,
        TlrTypId: 1,
        FullWt: ""
      })) : []
    }))


    setFileUploadData(o => ({
      ...o,
      addedFiles: [
        ...o.addedFiles,
        {
          file: data.file,
          fileNm: data.file.name,
          label: data.file.name,
          isEdit: false,
          imgLink: URL.createObjectURL(data.file)
        }
      ]
    }))
  }, [])

  useEffect(() => {

    if (dialogOpen) {
      setFileUploadData(JSON.parse(JSON.stringify(initFileUploadData())))
      setmShpmId(selectedId)
      if (selectedId > 0) {
        ax.post(shipmentApiNm.getShipment, { ShpmId: selectedId }).then(value => {
          const serverFiles = value.data[0].Files.map(item => ({
            id: item.ShpmFileId,
            fileNm: item.FileNm,
            label: item.Label,
            oLabel: item.Label,
            ShpmId: selectedId,
            isEdit: false,
            file: null,
            imgLink: `${window.location.origin}/${FOLDER_SHIPMENT_FILE}${item.ShpmId}/${item.FileNm}`,
          }))
          setFileUploadData({ ...initFileUploadData(), serverFiles })

          setDialogData(value.data[0])
          oldData = { ...value.data[0] }
          firstData = { ...value.data[0] };
        })
      }
    } else {

      setIsShowShipmentData(true)
      setMemoData([])
      setIsClearData(true)
      setDialogData({ ...initDialogData })
      setDialogPrintJobOrderOpen(false)
      firstData = { ...initDialogData }
      setmShpmId(0)
      setMenuAnchor(null)
      setSaving(false)
    }
  }, [dialogOpen, selectedId, ax])

  const subDialogs = (
    <>
      <PrintJobOrderDialog
        dialogOpen={dialogPrintJobOrderOpen}
        setDialogOpen={setDialogPrintJobOrderOpen}
        selectedId={mShpmId}
        onFinish={handlePrintDialogFinish} />
      <ReadFileDialog
        dialogOpen={dialogReadFileOpen}
        setDialogOpen={setDilaogReadFileOpen}
        onFinish={onDialogReadFileFinish}
      />
      <ReadBookingDialog
        dialogOpen={dialogReadFileBookingOpen}
        setDialogOpen={setDialogReadFileBookingOpen}
        onFinish={onDialogReadFileFinish} />
      <ReadBLDialog
        dialogOpen={dialogReadFileBLOpen}
        setDialogOpen={setDialogReadFileBLOpen}
        onFinish={onDialogReadFileFinish}
      />
      <LogTableDialog
        tableName="shipment_log"
        idColNm="ShpmId"
        idValue={mShpmId}
        excludeKeys={excludeKeys}
        colNm={shipmentColNm}
        title="ประวัติการแก้ไขข้อมูลใบแจ้งลาก"
        dialogOpen={dialogHistoryOpen}
        setDialogOpen={setDialogHistoryOpen}
      />
    </>
  )

  if (isCompact) {
    const isEdit = mShpmId > 0
    const numFile = fileUploadData.serverFiles.length + fileUploadData.addedFiles.length
    const cusNm = dialogData.CusId ? msData.cusCombo.find(item => item.id === dialogData.CusId)?.label : null
    const runSave = (withPrintJobOrder) => async () => {
      if (saving) return
      setSaving(true)
      try {
        await (withPrintJobOrder ? insertAndPrintJobOrder() : handleDialogOK(false))
      } finally {
        setSaving(false)
      }
    }
    const menuAction = (action) => () => {
      setMenuAnchor(null)
      action()
    }
    const sectionSx = { bgcolor: "background.paper", borderRadius: 2, p: 1.5 }
    return (
      <Dialog open={dialogOpen} fullScreen aria-labelledby="shd-compact-title"
        onClose={() => setDialogOpen(false)}
        PaperProps={{ sx: { bgcolor: blueGrey[50] } }}>
        <Box sx={{
          display: "flex", alignItems: "center", gap: 0.5, px: 0.5, pb: 0.5,
          pt: "calc(4px + env(safe-area-inset-top))", bgcolor: "primary.main", color: "primary.contrastText"
        }}>
          <IconButton color="inherit" aria-label="ปิด" onClick={() => setDialogOpen(false)}><CloseRounded /></IconButton>
          <Box flex={1} minWidth={0}>
            <Typography id="shd-compact-title" noWrap sx={{ fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
              {isEdit ? "แก้ไขใบแจ้งลาก" : "เพิ่มใบแจ้งลาก"}
            </Typography>
            <Typography noWrap sx={{ fontSize: 13, opacity: 0.85 }}>
              {[dialogData.JobNo, cusNm].filter(Boolean).join("  ·  ") || "กรอกข้อมูลใบแจ้งลากและรายการตู้"}
            </Typography>
          </Box>
          {isEdit ?
            <IconButton color="inherit" aria-label="เมนูเพิ่มเติม" aria-haspopup="menu"
              onClick={(e) => setMenuAnchor(e.currentTarget)}>
              <MoreVertRounded />
            </IconButton>
            : null}
        </Box>
        <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={() => setMenuAnchor(null)}>
          <MenuItem onClick={menuAction(handlePrintJobOrder)} sx={{ minHeight: 48 }}>
            <ListItemIcon><AddRounded /></ListItemIcon>เพิ่ม/พิมพ์ใบงาน
          </MenuItem>
          <MenuItem onClick={menuAction(handlePrintShipmet)} sx={{ minHeight: 48 }}>
            <ListItemIcon><PrintRounded /></ListItemIcon>พิมพ์ใบแจ้งลาก
          </MenuItem>
          <MenuItem onClick={menuAction(handleCopyShipment)} sx={{ minHeight: 48 }}>
            <ListItemIcon><ContentCopyRounded /></ListItemIcon>ทำซ้ำใบแจ้งลาก
          </MenuItem>
          <MenuItem onClick={menuAction(() => setDialogHistoryOpen(true))} sx={{ minHeight: 48 }}>
            <ListItemIcon><HistoryRounded /></ListItemIcon>ประวัติการแก้ไข
          </MenuItem>
          <Divider />
          <MenuItem onClick={menuAction(() => deleteShipment(mShpmId))} sx={{ minHeight: 48, color: "error.main" }}>
            <ListItemIcon><DeleteRounded color="error" /></ListItemIcon>ลบใบแจ้งลาก
          </MenuItem>
        </Menu>

        <Box sx={{ flex: 1, overflowY: "auto", p: 1, display: "flex", flexDirection: "column", gap: 1 }}>
          {isEdit ? null :
            <Box sx={sectionSx}>
              <Typography sx={{ fontWeight: 700, fontSize: 16 }}>กรอกอัตโนมัติจากไฟล์</Typography>
              <Typography sx={{ fontSize: 13, color: "text.secondary", mb: 1 }}>
                ถ่ายรูปหรือเลือกไฟล์เอกสาร ระบบจะอ่านข้อมูลมาใส่ให้
              </Typography>
              <Box sx={{ display: "grid", gap: 1, gridTemplateColumns: "repeat(3, minmax(0, 1fr))" }}>
                <Button variant="outlined" onClick={() => setDialogReadFileBookingOpen(true)}
                  startIcon={<DocumentScannerRounded />} sx={{ minHeight: 44, px: 1 }}>Booking</Button>
                <Button variant="outlined" onClick={() => setDialogReadFileBLOpen(true)}
                  startIcon={<DocumentScannerRounded />} sx={{ minHeight: 44, px: 1 }}>B/L</Button>
                <Button variant="outlined" onClick={() => setDilaogReadFileOpen(true)}
                  startIcon={<DocumentScannerRounded />} sx={{ minHeight: 44, px: 1 }}>อื่นๆ</Button>
              </Box>
            </Box>
          }
          <ShipmentData compact shipmentData={dialogData}
            setShipmentData={setDialogData}
            msData={msData}
            disabled={false}
            hideModAcc={true}
            validation={validation}
            oneYearVsslData={oneYearVsslData}
            oneYearPortData={oneYearPortData}
            compactJobOrderAction={isEdit ?
              <Button size="small" variant="contained" startIcon={<PrintRounded />} onClick={handlePrintJobOrder}
                sx={{ minHeight: 36 }}>
                เพิ่ม/พิมพ์ใบงาน
              </Button> : null} />
          <Box component="section" sx={sectionSx}>
            <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 1 }}>ไฟล์ ({numFile})</Typography>
            <FileUpload compact
              options={msData.serverData.PreText.ShipmentFiles || []}
              fileUploadData={fileUploadData}
              setFileUploadData={setFileUploadData}
            />
          </Box>
          <Box sx={{ px: 0.5 }}>
            {isEdit ?
              <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} /> :
              <CheckboxFormControl label="ล้างข้อมูลหลังจากเพิ่มใบแจ้งลาก" checked={isClearData} onChange={(e) => setIsClearData(e.target.checked)} />
            }
          </Box>
        </Box>

        {isShowShipmentData &&
          <Box sx={{
            display: "grid", gap: 1, px: 1, pt: 1, pb: "calc(8px + env(safe-area-inset-bottom))",
            bgcolor: "background.paper", borderTop: 1, borderColor: "divider",
            gridTemplateColumns: isEdit ? "minmax(0, 1fr) minmax(0, 2fr)" : "minmax(0, 0.8fr) minmax(0, 1.2fr) minmax(0, 1fr)"
          }}>
            <Button variant="outlined" onClick={() => setDialogOpen(false)} sx={{ minHeight: 48 }}>ยกเลิก</Button>
            {isEdit ? null :
              <Button variant="contained" color="secondary" disabled={saving} onClick={runSave(true)}
                startIcon={<PrintRounded />} sx={{ minHeight: 48, lineHeight: 1.2, px: 1 }}>
                เพิ่มและพิมพ์ใบงาน
              </Button>}
            <Button variant="contained" disabled={saving} onClick={runSave(false)}
              startIcon={<SaveRounded />} sx={{ minHeight: 48, lineHeight: 1.2, px: 1 }}>
              {saving ? "กำลังบันทึก" : isEdit ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
            </Button>
          </Box>
        }
        {subDialogs}
      </Dialog>
    )
  }

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="lg" >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={mShpmId ? "แก้ไขใบแจ้งลาก" : "เพิ่มใบแจ้งลาก"}
        onDeleteClick={mShpmId > 0 ? () => deleteShipment(mShpmId) : null}
      >
        {mShpmId > 0 ?
          <BoxFR>
            <Button sx={{ ml: 2 }} variant="contained" color="success" onClick={() => setDialogHistoryOpen(true)}>
              <HistoryRounded sx={{ mr: 1 }} />ประวัติ
            </Button>
            <Button variant="contained" color="secondary" onClick={handlePrintShipmet}>
              <PrintRounded sx={{ mr: 1 }} /> พิมพ์ใบแจ้งลาก
            </Button>
            <Button variant="contained" color="secondary" onClick={handleCopyShipment}>
              <ContentCopyRounded sx={{ mr: 1 }} /> ทำซำ้ใบแจ้งลาก
            </Button>
            <Button variant="contained" color="secondary" onClick={handlePrintJobOrder}>
              <PrintRounded sx={{ mr: 1 }} /> เพิ่มใบงาน
            </Button>
          </BoxFR>
          :
          <BoxFR ml={2}>
            <Button variant="contained" color="secondary" onClick={() => { setDialogReadFileBookingOpen(true) }}>
              <DocumentScannerRounded sx={{ mr: 1 }} />
              อ่านจากไฟล์ Booking</Button>
            <Button variant="contained" color="secondary" onClick={() => { setDialogReadFileBLOpen(true) }}>
              <DocumentScannerRounded sx={{ mr: 1 }} />
              อ่านจากไฟล์ B/L</Button>

            <Button variant="contained" color="secondary" onClick={() => { setDilaogReadFileOpen(true) }}>
              <DocumentScannerRounded sx={{ mr: 1 }} />
              อ่านจากไฟล์อื่นๆ</Button>
          </BoxFR>
        }
      </DialogHeader>
      <DialogContent sx={{ display: "flex", justifyContent: "center", gap: 2, bgcolor: blueGrey[50], pb: 1 }}>
        <Paper sx={{ p: 2, mt: 1 }}>

          <Box display="flex" flexDirection="row" mt={2} gap={1} flex={1} height={680} justifyContent="center">
            <BoxFC mt={-3} sx={{ gap: 1 }}>
              <ShipmentData shipmentData={dialogData}
                setShipmentData={setDialogData}
                msData={msData}
                width={660}
                disabled={false}
                hideModAcc={true}
                validation={validation}
                oneYearVsslData={oneYearVsslData}
                oneYearPortData={oneYearPortData} />
            </BoxFC>
            <BoxFC sx={{ gap: 1 }}>
              <FileUpload
                width={400}
                options={msData.serverData.PreText.ShipmentFiles || []}
                fileUploadData={fileUploadData}
                setFileUploadData={setFileUploadData}
              />
              {
                dialogData.ShpmId > 0 ?
                  <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} /> :
                  <CheckboxFormControl label="ล้างข้อมูลหลังจากเพิ่มใบแจ้งลาก" checked={isClearData} onChange={(e) => setIsClearData(e.target.checked)} />
              }
            </BoxFC>


            {/* <MemoComponent
            getArgs={dialogData.ShpmId > 0 && getMemoArgs}
            memTyp="SH"
            getApiNm={shipmentApiNm.getShipmentMemo}
            refId={dialogData.ShpmId}
            setMemoData={setMemoData} /> */}
          </Box>
        </Paper>
        {subDialogs}
      </DialogContent>
      {isShowShipmentData &&
        <DialogFooter okText={mShpmId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
          handleDialogClose={() => setDialogOpen(false)}
          handleDialogOk={() => handleDialogOK(false)} >
          {!mShpmId &&
            <Button variant="contained" color="secondary" onClick={insertAndPrintJobOrder}>
              <PrintRounded sx={{ mr: 1 }} />
              เพิ่มและพิมพ์ใบงาน
            </Button>
          }
        </DialogFooter>
      }
    </Dialog>
  )
}

export default React.memo(ShipmentDialog)